export default {"src":"/_next/static/media/icon_checkmark.e1fccbf6.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};